import React, {useEffect, useState, useRef} from 'react';
import "../ProductOverview/style.scss";
import "../style.scss";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getSingleFundDetailsquicklink, postNavOverview, postCompareList, postCompareListDublicate} from "../actions";
import { closePopup, openPopup } from "../../../general/Modal/action";
import { MODALS } from "../../../general/Modal/constants";
import {
  formDataGenerator,
  getRouting,
  getYoutubePosterImage,
  checkIframeContent
} from "../../../../../utils/common";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import LineGraph from '../LineGraph';
import PageNotFound from "../../PageNotFound";
import Modal from "react-modal";
import SocialShare from "../../../general/socials";
import cookie from 'react-cookies';
import Slider from "react-slick";
import { browserName } from 'react-device-detect';

// const utm_source = new URLSearchParams(window.location.search);
// const utmSource = utm_source.get("utm_source") || "";
// const utmMedium = utm_source.get("utm_medium") || "";

const FlexiCapPromotionQuickLink = (props) => {
  const {
    getSingleFundDetailsquicklink,
    productDetailOverview,
    postNavOverview,
    postNavList,
    postCompareList,
    postCompareListDublicate,
    compareListData,
    openPopup,
    closePopup,
    location: { pathname },
  } = props;

  const [faqselected, setfaqselected] = useState(0);
  const [toggleButton, settoggleButton] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);
  const [preSelectedYear, setpreSelectedYear] = useState("1 Year");
  const [preSelectedNav, setpreSelectedNav] = useState();
  const [amficodeNav, setamficodeNav] = useState();
  const [productDetail, setproductDetail] = useState();
  const [isExpanded, setIsExpanded] = useState(false);
  const [multipleNav, setmultipleNav] = useState();
  const [productNodeID, setproductNodeID] = useState();
  const [compareFundApiLoaded, setcompareFundApiLoaded] = useState(false);
  const [compareselectedArray, setcompareSelectedArray] = useState([]);
  const [toggleButtonCompare, settoggleButtonCompare] = useState(false);
  const [compareListTrending, setcompareListTrending] = useState();
  const [compareListSearch, setcompareListSearch] = useState();
  const [compareCards, setcompareCards] = useState();
  const [wordEntered, setWordEntered] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [share, setShare] = useState(false);
  const [cardId, setCardId] = useState(-1);
  const [metaData, setMetaData] = useState();
  const [manageApi, setManageApi] = useState(true);

  // Code to active menu on scroll
  const [activeSection, setActiveSection] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = document.querySelectorAll("section[id]");
      const scrollPosition = window.scrollY;

      sectionElements.forEach((section) => {
        const { top, bottom } = section.getBoundingClientRect();
        if (top <= 200 && bottom > 0) {
          setActiveSection(section.id);
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Code to active menu on scroll
  const [isSidebarFixed, setSidebarFixed] = useState(false);
  const [isrightFixed, setisrightFixed] = useState(false);
  useEffect(() => {
    const handleScrollDown = () => {
      const sidebarWrap = document.getElementById("sidebarWrap");
      const sidebar = document.getElementById("sidebar");
      const top =
        sidebar.offsetTop -
        parseFloat(window.getComputedStyle(sidebar).marginTop);
      const footerId = document.getElementById("footerID");
      let footerTop = 0;
      if(footerId){
      footerTop =
        footerId.offsetTop -
          300 +
          -parseFloat(
            window.getComputedStyle(footerId).marginTop
          );
      }
      const maxY = footerTop - sidebar.offsetHeight;
      const y = window.scrollY;
      if(checkIframeContent() && (isWebViewData == true)){
        if (y > 200 && y < maxY) {
          setSidebarFixed(true);
        } else {
          setSidebarFixed(false);
        }
      }
      else{
        if (y > 200) {
          setSidebarFixed(true);
        } else {
          setSidebarFixed(false);
        }
      }
    };
    window.addEventListener("scroll", handleScrollDown);
    return () => {
      window.removeEventListener("scroll", handleScrollDown);
    };
  }, []);
  useEffect(()=>{
    if(isDesktop === true){
      const handleScrollDownright = () => {
        // const sidebarWrap = document.getElementById("sidebarWrap");
        const rightsidebar = document.getElementById("rightsidebar");
        const top =
        rightsidebar.offsetTop -
          parseFloat(window.getComputedStyle(rightsidebar).marginTop);
          const footerId = document.getElementById("footerID");
        let footerTop = 0;
        if(footerId){
          footerTop =
            footerId.offsetTop -
              800 +
              -parseFloat(
                window.getComputedStyle(footerId).marginTop
              );
        }
        const maxY = footerTop - rightsidebar.offsetHeight;
        const y = window.scrollY;
        if(checkIframeContent() && (isWebViewData == true)){
          if (y > 200 && y < maxY) {
            setisrightFixed(true);
          } else {
            setisrightFixed(false);
          }
        }
        else{
          if (y > 200) {
            setisrightFixed(true);
          } else {
            setisrightFixed(false);
          }
        }
      };
      window.addEventListener("scroll", handleScrollDownright);
      return () => {
        window.removeEventListener("scroll", handleScrollDownright);
      };
    }
  },[isDesktop])

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsDesktop(window.innerWidth > 767);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange(); // Call the function initially to set the initial state
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  useEffect(()=>{
    if(productDetailOverview && productDetailOverview.productOverview){
      setproductDetail(productDetailOverview.productOverview);
    }
    if (
      productDetailOverview &&
      productDetailOverview.productOverview &&
      productDetailOverview.productOverview.nodeID
    ) {
      setproductNodeID(productDetailOverview.productOverview.nodeID);
    }
    if(productDetailOverview &&
      productDetailOverview.productOverview &&
      productDetailOverview.productOverview.meta){
      setMetaData(productDetailOverview &&
        productDetailOverview.productOverview &&
        productDetailOverview.productOverview.meta);
    }
  },[productDetailOverview, productDetail])

  useEffect(() => {
    const typeData = 'hdfc-flexi-cap-fund';

    let params = {
      plan_type: 'direct',
    };
    getSingleFundDetailsquicklink({},formDataGenerator(params), typeData);
    closePopup();
  }, []);
  useEffect(() => {
    const typeData = 'hdfc-flexi-cap-fund';
    let formData = 'direct';

    const is_real_nav_data = true;
    
    let paramsTypes = {
      plan_type: formData,
      is_fund_facts: is_real_nav_data,
    };
    postNavOverview(formDataGenerator(paramsTypes), typeData);
  }, [productDetail]);

  // useEffect(() => {
  //   let params = {
  //     is_fund_facts: "",
  //   };
  //   const urlName = 'hdfc-flexi-cap-fund';
  //   if (
  //     productDetail &&
  //     productDetail.banner &&
  //     productDetail.banner.categories &&
  //     productDetail.banner.categories[0] == "ETF"
  //   ) {
  //     const apiInterval = setInterval(() => {
  //       postNavOverview(formDataGenerator(params), urlName);
  //     }, 5000);

  //     return () => {
  //       // clean up
  //       clearInterval(apiInterval);
  //     };
  //   }
  // }, [productDetail]);

  useEffect(() => {
    if (
      postNavList &&
      postNavList.navOverview &&
      postNavList.navOverview.navs
    ) {
      setmultipleNav(postNavList.navOverview.navs);
    }
    if (
      postNavList &&
      postNavList.navOverview &&
      postNavList.navOverview.navs &&
      postNavList.navOverview.navs[0] &&
      postNavList.navOverview.navs[0].planName
    ) {
      setpreSelectedNav(postNavList.navOverview.navs[0].planName);
    }
    if(postNavList &&
      postNavList.navOverview &&
      postNavList.navOverview.navs &&
      postNavList.navOverview.navs[0] &&
      postNavList.navOverview.navs[0].amfiCode)
    {
    setamficodeNav(postNavList.navOverview.navs[0].amfiCode);
    }
  }, [postNavList]);
  // comapre card
  useEffect(() => {
    if (compareselectedArray.length <= 3 && compareFundApiLoaded) {
      let params = {
        nodeID: compareselectedArray.toString(),
        plan_type: toggleButtonCompare == false ? "direct" : "indirect",
      };
      postCompareListDublicate(formDataGenerator(params));
    }
  }, [compareselectedArray, toggleButtonCompare]);

  useEffect(() => {
    if (
      compareListData &&
      compareListData.compareList &&
      compareListData.compareList.nodes
    ) {
      setcompareListSearch(compareListData.compareList.nodes);
    }
    if (
      compareListData &&
      compareListData.compareList &&
      compareListData.compareList.trending
    ) {
      setcompareListTrending(compareListData.compareList.trending);
    }
    if (
      compareListData &&
      compareListData.compareList &&
      compareListData.compareList.cards
    ) {
      setcompareCards(compareListData.compareList.cards);
    }
  }, [compareListData, compareListTrending]);

  useEffect(() => {
    if (
      postNavList &&
      postNavList.navOverview &&
      postNavList.navOverview.navs &&
      postNavList.navOverview.navs[0]
    ) {
      const arrayMapUpdate = [];

      compareCards &&
        compareCards.length > 0 &&
        compareCards.map((item) => {
          if (
            item.real_nav === true &&
            item.nodeID == postNavList.navOverview.navs[0].fundId
          ) {
            item.nav = postNavList.navOverview.navs[0].navValue;
            item.navAsMonth = postNavList.navOverview.navs[0].navDate;
            arrayMapUpdate.push(item);
          } else {
            arrayMapUpdate.push(item);
          }
        });
      setcompareCards(arrayMapUpdate);
    }
  }, [postNavList]);

  useEffect(() => {
    let params = {
      is_fund_facts: "",
    };
    const apiInterval = setInterval(() => {
      compareCards &&
        compareCards.length > 0 &&
        compareCards.map((itemNav) => {
          if (itemNav.real_nav === true) {
            postNavOverview(formDataGenerator(params), itemNav.suggestedUrl);
          }
        });
    }, 5000);
    return () => {
      // clean up
      clearInterval(apiInterval);
    };
  }, [compareCards]);


  const handlePlanChange = (e) => {
    settoggleButton(e.target.checked);
    setManageApi(true);
    const typeData = 'hdfc-flexi-cap-fund';

    let togglrForm = "";
    if (e.target.checked == false) {
      togglrForm = "direct";
    } else {
      togglrForm = "indirect";
    }

    let params = {
      plan_type: togglrForm,
    };
    getSingleFundDetailsquicklink({},formDataGenerator(params), typeData);
  }
  const faqtoggle = (index) => {
    if (faqselected == index) {
      return setfaqselected(null);
    }
    setfaqselected(index);
  };
  const handleOverviewReturn=(e)=>{
    setpreSelectedYear(e.target.value);
  }
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  
  const handleOverviewNav = (e) => {
    setpreSelectedNav(e.target.value);
    setManageApi(true);
    multipleNav && multipleNav.length > 0 &&  multipleNav
    .filter((item)=> item.planName === e.target.value)
    .map((item, index)=>{
      setamficodeNav(item.amfiCode);
    })
  };
  const [fundSelected, setfundSelected] = useState(null);
  const fundtoggle = (index) => {
    if (fundSelected === index) {
      return setfundSelected(null);
    }
    setfundSelected(index);
  };
  const [overseasSelected, setoverseasSelected] = useState(null);
  const overseastoggle = (index) => {
    if (overseasSelected === index) {
      return setoverseasSelected(null);
    }
    setoverseasSelected(index);
  };

  //modal1
  const [modalshow, setModalShow] = useState(false);

  const modalhandleClose = () => {
    setModalShow(false);
    setcompareFundApiLoaded(false);
  }
  const modalhandleShow = () => {
    setModalShow(true);
    setcompareSelectedArray([...compareselectedArray, productNodeID]);
    setcompareFundApiLoaded(true);

    // settoggleButtonCompare(true);
  };
  const handleCompareCheckBox = (e) => {
    const myArray = [];

    // true false
    compareListTrending &&
      compareListTrending.length > 0 &&
      compareListTrending.map((item) => {
        if (item.nodeID === e.nodeID && item.checked === false) {
          item.checked = true;
          myArray.push(item);
        } else if (item.nodeID === e.nodeID && item.checked === true) {
          item.checked = false;
          myArray.push(item);
        }
      });
    setcompareListTrending(myArray);

    // add value to array

    let newArray = [];
    if (e.checked == false) {
      compareselectedArray &&
        compareselectedArray.map((itemVal) => {
          if (itemVal != e.nodeID) {
            newArray.push(itemVal);
          }
        });
      setcompareSelectedArray(newArray);
    } else if (e.checked == true) {
      const uniqueNames = [...compareselectedArray, e.nodeID];
      setcompareSelectedArray(Array.from(new Set(uniqueNames)));
    }
  };

  const handleRemoveCard = (e) => {
    let myArray = [];
    compareselectedArray &&
      compareselectedArray.map((itemVal) => {
        if (itemVal != e) {
          myArray.push(itemVal);
        }
      });
    setcompareSelectedArray(myArray);
  };

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);

    const newFilter = compareListSearch.filter((value) => {
      return value.title.toLowerCase().includes(searchWord.toLowerCase());
    });

    if (searchWord === "") {
      setFilteredData([]);
    } else {
      setFilteredData(newFilter);
    }
  };

  const clearInput = () => {
    setFilteredData([]);
    setWordEntered("");
  };

  const handleAddCard = (e) => {
    if (compareselectedArray.length < 3) {
      let nodeName = "";

      compareListSearch &&
        compareListSearch.map((itemVal) => {
          if (itemVal.title == e) {
            nodeName = itemVal.nodeID;
          }
        });

      const uniqueNames = [...compareselectedArray, nodeName];
      setcompareSelectedArray(Array.from(new Set(uniqueNames)));
    }
    clearInput();
  };

  const handleFundYearCompare = (event) => {
    const arrayMap = compareCards;
    const arrayMapUpdate = [];

    arrayMap.map((item) => {
      if (item.nodeID == event.cardID) {
        item.isActive = event.yearName;
        arrayMapUpdate.push(item);
      } else {
        arrayMapUpdate.push(item);
      }
    });
    setcompareCards(arrayMapUpdate);
  };
  const handlePlanChangeCompare = (e) => {
    settoggleButtonCompare(e.target.checked);
  };

  const handleClickShare = (key) => {
    setCardId(key);
    if (cardId == -1 || cardId === key) setShare((prev) => !prev);
    setShare(true);
  };
  const addTodo = () => {
    setShare(false);
  };

  let isWebViewData = true;
  if(browserName && (browserName.includes('WebView') || browserName.includes('WebKit'))){
    isWebViewData = false;
  }

  // const onAddToCartClick = (fundName, fundCode, returnVal, invest) => {
  //   if(invest == "Invest Now"){
  //     cookie.save("isInvest", true, { path: "/" });
  //   }
  //   else{
  //     cookie.save("isInvest", false, { path: "/" });
  //   } 

  //   let modalData = {
  //     modalClass: "ecart-modal",
  //     fundName: fundName,
  //     fundCode: fundCode,
  //     isDirect: toggleButton == false ? true : false,
  //     isRegular: toggleButton == true ? true : false,
  //     returnValue: { duration: "11", value: returnVal ? returnVal : "" },
  //     invest: invest,
  //     // utmSource: utmSource,
  //     // utmMedium: utmMedium,

  //   };
  //   openPopup(MODALS.ECART_MODAL, modalData);
  //   investmodalhandleClose();
  // };

  const sharename = "";
  const etfBtn = "hdfc-flexi-cap-fund";

  //dropdown start

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenmobile, setIsOpenmobile] = useState(false);
  const [isOpendesktop, setIsOpendesktop] = useState(false);
  
  const dropdownRef = useRef(null);
  const dropdownRefMobile = useRef(null);
  const dropdownRefdesktop = useRef(null);

  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };
  const toggleDropDownMobile = () => {
    setIsOpenmobile(!isOpenmobile);
  };
  const toggleDropDowndesktop = () => {
    setIsOpendesktop(!isOpendesktop);
  };
  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };
  const handleClickOutmobile = (event) => {
    if (dropdownRefMobile.current && !dropdownRefMobile.current.contains(event.target)) {
      setIsOpenmobile(false);
    }
  };
  const handleClickOutdesktop = (event) => {
    if (dropdownRefdesktop.current && !dropdownRefdesktop.current.contains(event.target)) {
      setIsOpendesktop(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    document.addEventListener("click", handleClickOutmobile);
    document.addEventListener("click", handleClickOutdesktop);    
    return () => {
      document.removeEventListener("click", handleClickOut);
      document.removeEventListener("click", handleClickOutmobile);
      document.removeEventListener("click", handleClickOutdesktop);
    };
  }, [isOpen, isOpenmobile, isOpendesktop]);

  //dropdown end
  const settingsNewFund = {
    dots: productDetail &&
    productDetail.banner &&
    productDetail.banner.promotionalBanners &&
    productDetail.banner.promotionalBanners.length > 1 ? true : false,
    infinite: productDetail &&
    productDetail.banner &&
    productDetail.banner.promotionalBanners &&
    productDetail.banner.promotionalBanners.length > 1 ? true : false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: productDetail &&
    productDetail.banner &&
    productDetail.banner.promotionalBanners &&
    productDetail.banner.promotionalBanners.length > 1 ? true : false,
    autoplaySpeed: 3000,
    draggable: productDetail &&
    productDetail.banner &&
    productDetail.banner.promotionalBanners &&
    productDetail.banner.promotionalBanners.length > 1 ? true : false,
    swipe: productDetail &&
    productDetail.banner &&
    productDetail.banner.promotionalBanners &&
    productDetail.banner.promotionalBanners.length > 1 ? true : false,
  }
  const [investmodalshow, setInvestModalShow] = useState(false);

  const investmodalhandleClose = () => {
    setInvestModalShow(false);
  }
  const investmodalhandleShow = () => {
    setInvestModalShow(true);
  };
  const maxLength = 35;
  const maxLengthmob = 21;
  return (
    <div className={checkIframeContent() && isWebViewData ? "wrapper":""}>
      {metaData && metaData != null ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={
              metaData && metaData.description ? metaData.description : ""
            }
          />
          <meta
            name="keywords"
            content={metaData && metaData.keywords ? metaData.keywords : ""}
          />
          <meta
            property="og:title"
            content={metaData && metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={
              metaData && metaData.og_description ? metaData.og_description : ""
            }
          />
          <meta
            property="og:image"
            content={metaData && metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData && metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      ) : (
        ""
      )}
      <div className='productOverview'>
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex">
              <div className="me-auto">
                <p>
                  <span>Product & </span> Solutions
                </p>
              </div>
              {isWebViewData && <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inlin"
              >
                <ol className="breadcrumb mb-0">
                  {checkIframeContent() && <li className="breadcrumb-item d-flex">
                    <a href="/">Home</a>
                  </li>}
                  <li className="breadcrumb-item d-flex">
                  {checkIframeContent() ? <a href="/product-solutions">Products</a>:<Link to={getRouting("/product-solutions")}>Products</Link>}
                  </li>
                  <li className="breadcrumb-item d-flex active breadcolor">
                    {productDetail &&
                      productDetail.banner &&
                      productDetail.banner.title}
                  </li>
                </ol>
              </nav>}
            </div>
          </div>
        </section>
        <section className='heading-section'>
          <div className='container'>
            <div className='heading-title'>
              <div className='titlediv'>
                {productDetail && productDetail.banner && productDetail.banner.title ?
                  <h1>{productDetail.banner.title}</h1>
                :''}
                {isDesktop === false && isWebViewData && checkIframeContent() && 
                <div ref={dropdownRef} className='mobiledropdown'>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='ms-3 mt-2 threedot' onClick={toggleDropDown}>
                    <path d="M15.5 10.166C15.7761 10.166 16 9.94216 16 9.66602C16 9.38987 15.7761 9.16602 15.5 9.16602C15.2239 9.16602 15 9.38987 15 9.66602C15 9.94216 15.2239 10.166 15.5 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.66699 10.166C9.94313 10.166 10.167 9.94216 10.167 9.66602C10.167 9.38987 9.94313 9.16602 9.66699 9.16602C9.39085 9.16602 9.16699 9.38987 9.16699 9.66602C9.16699 9.94216 9.39085 10.166 9.66699 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3.83301 10.166C4.10915 10.166 4.33301 9.94216 4.33301 9.66602C4.33301 9.38987 4.10915 9.16602 3.83301 9.16602C3.55687 9.16602 3.33301 9.38987 3.33301 9.66602C3.33301 9.94216 3.55687 10.166 3.83301 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {isOpen && (
                    <ul
                      className="dropdown-body"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <li>
                        <div onClick={modalhandleShow} className='d-flex align-items-center'>
                          <svg width="15" height="15" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" className='arrows' onClick={modalhandleShow}>
                            <path d="M7 17.725L6.115 16.8338L9.98375 12.9663H0.75V11.7163H9.98375L6.115 7.84875L7 6.9575L12.385 12.3413L7 17.725ZM17 11.0188L11.615 5.635L17 0.25L17.885 1.1425L14.0175 5.01H23.25V6.26H14.0175L17.885 10.1275L17 11.0188Z" fill="#231F20"/>
                          </svg>
                          <p className='ms-2 text'>Compare</p>
                        </div>
                      </li>
                      <li>
                        <div className="sharebtn" onClick={() => handleClickShare(0)}>
                          <div className='d-flex align-items-center'>
                            <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='share'>
                              <path d="M15 18.334C16.3807 18.334 17.5 17.2147 17.5 15.834C17.5 14.4533 16.3807 13.334 15 13.334C13.6193 13.334 12.5 14.4533 12.5 15.834C12.5 17.2147 13.6193 18.334 15 18.334Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M7.1582 11.2578L12.8499 14.5745" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M15 6.66602C16.3807 6.66602 17.5 5.54673 17.5 4.16602C17.5 2.7853 16.3807 1.66602 15 1.66602C13.6193 1.66602 12.5 2.7853 12.5 4.16602C12.5 5.54673 13.6193 6.66602 15 6.66602Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.8415 5.42578L7.1582 8.74245" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <p className='ms-2 text'>share</p>
                          </div>
                          {share && cardId === 0 && (
                            <SocialShare fundName={sharename} addTodo={addTodo} />
                          )}
                        </div>
                      </li>
                    </ul>
                  )}
                </div>}
              </div>
              {isDesktop && productDetail && productDetail.banner && productDetail.banner.categories && productDetail.banner.categories[0] ?
                <p className='type'>{productDetail.banner.categories[0]}</p>: ''}
              {isDesktop && isWebViewData && checkIframeContent() && 
                <>
                <div className='producttooltip'>
                  <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" className='arrows' onClick={modalhandleShow}>
                    <path d="M7 17.725L6.115 16.8338L9.98375 12.9663H0.75V11.7163H9.98375L6.115 7.84875L7 6.9575L12.385 12.3413L7 17.725ZM17 11.0188L11.615 5.635L17 0.25L17.885 1.1425L14.0175 5.01H23.25V6.26H14.0175L17.885 10.1275L17 11.0188Z" fill="#231F20"/>
                  </svg>
                  <div className="tooltiptext btns">
                      <p>Compare Funds</p>
                  </div>
                </div>
                <div className="sharebtn producttooltip" onClick={() => handleClickShare(0)}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='share'>
                    <path d="M15 18.334C16.3807 18.334 17.5 17.2147 17.5 15.834C17.5 14.4533 16.3807 13.334 15 13.334C13.6193 13.334 12.5 14.4533 12.5 15.834C12.5 17.2147 13.6193 18.334 15 18.334Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.1582 11.2578L12.8499 14.5745" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15 6.66602C16.3807 6.66602 17.5 5.54673 17.5 4.16602C17.5 2.7853 16.3807 1.66602 15 1.66602C13.6193 1.66602 12.5 2.7853 12.5 4.16602C12.5 5.54673 13.6193 6.66602 15 6.66602Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.8415 5.42578L7.1582 8.74245" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div className="tooltiptext btns">
                    <p>Share</p>
                  </div>
                  {share && cardId === 0 && (
                    <SocialShare fundName={sharename} addTodo={addTodo} />
                  )}
                </div>
                </>
              }
            </div>
            <p className='sub-heading'>
            {productDetail &&
              productDetail.details &&
              productDetail.details[0] &&
              productDetail.details[0].Overview &&
              productDetail.details[0].Overview.data &&
              productDetail.details[0].Overview.data.sutiableFor &&
              productDetail.details[0].Overview.data.sutiableFor.length > 0 &&
              productDetail.details[0].Overview.data.sutiableFor.join('/')}
            </p>
            {isDesktop === false && productDetail && productDetail.banner && productDetail.banner.categories && productDetail.banner.categories[0] ? <p className='type'>{productDetail.banner.categories[0]}</p> : ''}
          </div>
          <div className={isSidebarFixed ? "menuflot" : "menulist"}>
            <div id="sidebarWrap">
              <div className={isSidebarFixed ? "fixed" : "scrollnav"}>
                {isSidebarFixed && isDesktop === false ?
                  <div className='d-flex align-items-center justify-content-between pt-1'>
                    <div className='d-flex align-items-center'>
                      <a href='/' className='logo'><img src='/images/hdfc_logo.svg' className='ms-3' alt='logo' width="57" height="24" /></a>
                      {productDetail && 
                        productDetail.banner && 
                        productDetail.banner.title &&
                        productDetail.banner.title.length > maxLengthmob ? 
                        <p className='fundNametitle mx-3'>{productDetail.banner.title.substring(0, maxLengthmob) + `.....`}</p> : 
                        <p className='fundNametitle mx-3'>{productDetail && productDetail.banner && productDetail.banner.title ? productDetail.banner.title :''}</p>}
                    </div>
                    {isDesktop === false && isWebViewData && checkIframeContent() && 
                    <div ref={dropdownRefMobile} className='mobiledropdown'>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='me-2 mt-2 threedot' onClick={toggleDropDownMobile}>
                        <path d="M15.5 10.166C15.7761 10.166 16 9.94216 16 9.66602C16 9.38987 15.7761 9.16602 15.5 9.16602C15.2239 9.16602 15 9.38987 15 9.66602C15 9.94216 15.2239 10.166 15.5 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.66699 10.166C9.94313 10.166 10.167 9.94216 10.167 9.66602C10.167 9.38987 9.94313 9.16602 9.66699 9.16602C9.39085 9.16602 9.16699 9.38987 9.16699 9.66602C9.16699 9.94216 9.39085 10.166 9.66699 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3.83301 10.166C4.10915 10.166 4.33301 9.94216 4.33301 9.66602C4.33301 9.38987 4.10915 9.16602 3.83301 9.16602C3.55687 9.16602 3.33301 9.38987 3.33301 9.66602C3.33301 9.94216 3.55687 10.166 3.83301 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      {isOpenmobile && (
                        <ul
                          className="dropdown-body"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <li>
                            <div onClick={modalhandleShow} className='d-flex align-items-center'>
                              <svg width="15" height="15" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" className='arrows' onClick={modalhandleShow}>
                                <path d="M7 17.725L6.115 16.8338L9.98375 12.9663H0.75V11.7163H9.98375L6.115 7.84875L7 6.9575L12.385 12.3413L7 17.725ZM17 11.0188L11.615 5.635L17 0.25L17.885 1.1425L14.0175 5.01H23.25V6.26H14.0175L17.885 10.1275L17 11.0188Z" fill="#231F20"/>
                              </svg>
                              <p className='ms-2 text'>Compare</p>
                            </div>
                          </li>
                          <li>
                            <div className="sharebtn" onClick={() => handleClickShare(0)}>
                              <div className='d-flex align-items-center'>
                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='share'>
                                  <path d="M15 18.334C16.3807 18.334 17.5 17.2147 17.5 15.834C17.5 14.4533 16.3807 13.334 15 13.334C13.6193 13.334 12.5 14.4533 12.5 15.834C12.5 17.2147 13.6193 18.334 15 18.334Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M7.1582 11.2578L12.8499 14.5745" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M15 6.66602C16.3807 6.66602 17.5 5.54673 17.5 4.16602C17.5 2.7853 16.3807 1.66602 15 1.66602C13.6193 1.66602 12.5 2.7853 12.5 4.16602C12.5 5.54673 13.6193 6.66602 15 6.66602Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M12.8415 5.42578L7.1582 8.74245" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p className='ms-2 text'>share</p>
                              </div>
                              {share && cardId === 0 && (
                                <SocialShare fundName={sharename} addTodo={addTodo} />
                              )}
                            </div>
                          </li>
                        </ul>
                      )}
                    </div>}
                  </div>
                :''}
                <div className='d-flex align-items-center justify-content-between'>
                  <ul id="sidebar">
                    {isSidebarFixed && isDesktop ?
                    <li>
                      <div className='d-flex align-items-center'>
                        <a href='/' className='logo'><img src='/images/hdfc_logo.png' className='ms-3' alt='logo' width="100" height="50" /></a>
                        {productDetail && 
                        productDetail.banner && 
                        productDetail.banner.title &&
                        productDetail.banner.title.length > maxLength ? 
                        <p className='fundNametitle mx-3'>{productDetail.banner.title.substring(0, maxLength) + `.....`}</p> : 
                        <p className='fundNametitle mx-3'>{productDetail && productDetail.banner && productDetail.banner.title ? productDetail.banner.title :''}</p>}
                      </div>
                    </li> : '' }
                    <li>
                      <a
                        href="#Performance"
                        className={
                          activeSection === "Performance" ? "active" : ""
                        }
                      >
                        Performance
                      </a>
                    </li>
                    {productDetail && productDetail.details &&
                      productDetail.details[0] &&
                      productDetail.details[0].Overview &&
                      ((productDetail.details[0].Overview.overviewDescription) || (productDetail.details[0].Overview.whyChooseAFund))  ?
                      <li>
                        <a
                          href="#Overview"
                          className={
                            activeSection === "Overview" ? "active" : ""
                          }
                        >
                          Overview
                        </a>
                      </li> : ''}
                    {productDetail && productDetail.details &&
                      productDetail.details[10] &&
                      productDetail.details[10].keyBenefits &&
                      productDetail.details[10].keyBenefits.length > 0 ?
                    <li>
                      <a
                        href="#Benefits"
                        className={
                          activeSection === "Benefits" ? "active" : ""
                        }
                      >
                        Benefits
                      </a>
                    </li>: ''}
                    <li>
                      <a
                        href="#FundDetails"
                        className={
                          activeSection === "FundDetails" ? "active" : ""
                        }
                      >
                        Fund Details
                      </a>
                    </li>
                    {productDetail &&
                      productDetail.details &&
                      productDetail.details[1] &&
                      ((productDetail.details[1].managers &&
                      productDetail.details[1].managers.length > 0) ||
                      (productDetail.details[1].overseasManagers &&
                      productDetail.details[1].overseasManagers.length)) ?
                    <li>
                      <a
                        href="#FundManagers"
                        className={
                          activeSection === "FundManagers" ? "active" : ""
                        }
                      >
                        Fund Managers
                      </a>
                    </li>:''}
                    {productDetail &&
                      productDetail.details &&
                      productDetail.details[3] &&
                      productDetail.details[3].top_10_holdings &&
                      productDetail.details[3].top_10_holdings.data &&
                      productDetail.details[3].top_10_holdings.data.length > 0 ?
                    <li>
                      <a
                        href="#Portfolio"
                        className={
                          activeSection === "Portfolio" ? "active" : ""
                        }
                      >
                        Portfolio
                      </a>
                    </li>:''}
                    {productDetail &&
                      productDetail.details &&
                      productDetail.details[5] &&
                      ((productDetail.details[5].schemeSummaryFiles 
                        && productDetail.details[5].schemeSummaryFiles.length > 0) || 
                        (productDetail.details[5].values && 
                          productDetail.details[5].values.length > 0))  ?
                    <li>
                      <a
                        href="#SchemeDocuments"
                        className={
                          activeSection === "SchemeDocuments" ? "active" : ""
                        }
                      >
                        Scheme Documents
                      </a>
                    </li>:''}
                  </ul>
                  {isDesktop && isSidebarFixed && isWebViewData && checkIframeContent() && 
                    <div ref={dropdownRefdesktop} className='mobiledropdown'>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='me-2 mt-2 threedot cursorp' onClick={toggleDropDowndesktop}>
                        <path d="M15.5 10.166C15.7761 10.166 16 9.94216 16 9.66602C16 9.38987 15.7761 9.16602 15.5 9.16602C15.2239 9.16602 15 9.38987 15 9.66602C15 9.94216 15.2239 10.166 15.5 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M9.66699 10.166C9.94313 10.166 10.167 9.94216 10.167 9.66602C10.167 9.38987 9.94313 9.16602 9.66699 9.16602C9.39085 9.16602 9.16699 9.38987 9.16699 9.66602C9.16699 9.94216 9.39085 10.166 9.66699 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M3.83301 10.166C4.10915 10.166 4.33301 9.94216 4.33301 9.66602C4.33301 9.38987 4.10915 9.16602 3.83301 9.16602C3.55687 9.16602 3.33301 9.38987 3.33301 9.66602C3.33301 9.94216 3.55687 10.166 3.83301 10.166Z" fill="#231F20" stroke="#231F20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      {isOpendesktop && (
                        <ul
                          className="dropdown-body"
                          aria-labelledby="dropdownMenuLink"
                        >
                          <li>
                            <div onClick={modalhandleShow} className='d-flex align-items-center'>
                              <svg width="15" height="15" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg" className='arrows' onClick={modalhandleShow}>
                                <path d="M7 17.725L6.115 16.8338L9.98375 12.9663H0.75V11.7163H9.98375L6.115 7.84875L7 6.9575L12.385 12.3413L7 17.725ZM17 11.0188L11.615 5.635L17 0.25L17.885 1.1425L14.0175 5.01H23.25V6.26H14.0175L17.885 10.1275L17 11.0188Z" fill="#231F20"/>
                              </svg>
                              <p className='ms-2 text'>Compare</p>
                            </div>
                          </li>
                          <li>
                            <div className="sharebtn" onClick={() => handleClickShare(0)}>
                              <div className='d-flex align-items-center'>
                                <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className='share'>
                                  <path d="M15 18.334C16.3807 18.334 17.5 17.2147 17.5 15.834C17.5 14.4533 16.3807 13.334 15 13.334C13.6193 13.334 12.5 14.4533 12.5 15.834C12.5 17.2147 13.6193 18.334 15 18.334Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M5 12.5C6.38071 12.5 7.5 11.3807 7.5 10C7.5 8.61929 6.38071 7.5 5 7.5C3.61929 7.5 2.5 8.61929 2.5 10C2.5 11.3807 3.61929 12.5 5 12.5Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M7.1582 11.2578L12.8499 14.5745" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M15 6.66602C16.3807 6.66602 17.5 5.54673 17.5 4.16602C17.5 2.7853 16.3807 1.66602 15 1.66602C13.6193 1.66602 12.5 2.7853 12.5 4.16602C12.5 5.54673 13.6193 6.66602 15 6.66602Z" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M12.8415 5.42578L7.1582 8.74245" stroke="#231F20" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p className='ms-2 text'>share</p>
                              </div>
                              {share && cardId === 0 && (
                                <SocialShare fundName={sharename} addTodo={addTodo} />
                              )}
                            </div>
                          </li>
                        </ul>
                      )}
                    </div>}
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className='mainsec'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-8 margincls order-2'>
                <div className='backcolor'>
                  <section id="Performance">
                    <h2 className='sectionheading'>Performance</h2>
                    {etfBtn && amficodeNav && <LineGraph urlFund={etfBtn} amficode={amficodeNav} manageApi={manageApi} setManageApi={setManageApi}/>}
                    <div>
                      {productDetail &&
                        productDetail.details &&
                        productDetail.details[2] &&
                        productDetail.details[2].performanceData && 
                        productDetail.details[2].performanceData.count && 
                        productDetail.details[2].performanceData.count > 0 ? 
                        <>
                          <p className='title'>Scheme Returns</p>
                          <div className="table-responsive">
                            <table className="table performancetable">
                              <thead>
                                <tr>
                                  <th>Parameters</th>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.year &&
                                    productDetail.details[2].performanceData.year.length > 0 &&
                                    productDetail.details[2].performanceData.year.map((item, index)=>(
                                        <th>{item.year ? item.year : ""}</th>
                                      )
                                    )}
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Scheme Returns (%)</td>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.annulaisedPer && 
                                    productDetail.details[2].performanceData.annulaisedPer.length > 0 &&
                                    productDetail.details[2].performanceData.annulaisedPer.map((item, index)=>(
                                      <td>{item.value ? item.value : ""}</td>
                                    ))  
                                    }
                                </tr>
                                <tr>
                                  <td>Benchmark Returns (%)#</td>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.benchmarkPer && 
                                    productDetail.details[2].performanceData.benchmarkPer.length > 0 &&
                                    productDetail.details[2].performanceData.benchmarkPer.map((item, index)=>(
                                      <td>{item.value ? item.value : ""}</td>
                                    ))  
                                    }
                                </tr>
                                <tr>
                                  <td>Additional Benchmark Returns (%)##</td>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.additionalBenchmarkPer && 
                                    productDetail.details[2].performanceData.additionalBenchmarkPer.length > 0 &&
                                    productDetail.details[2].performanceData.additionalBenchmarkPer.map((item, index)=>(
                                      <td>{item.value ? item.value : ""}</td>
                                    ))  
                                    }
                                </tr>
                                <tr>
                                  <td colspan="6" className='text-center trback'>Value of Investment of ₹ 10,000</td>
                                </tr>
                                <tr>
                                  <td>Scheme (₹)</td>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.annulaised && 
                                    productDetail.details[2].performanceData.annulaised.length > 0 &&
                                    productDetail.details[2].performanceData.annulaised.map((item, index)=>(
                                      <td>{item.value ? item.value : ""}</td>
                                    ))  
                                    }
                                </tr>
                                <tr>
                                  <td>Benchmark (₹)#</td>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.benchmark && 
                                    productDetail.details[2].performanceData.benchmark.length > 0 &&
                                    productDetail.details[2].performanceData.benchmark.map((item, index)=>(
                                      <td>{item.value ? item.value : ""}</td>
                                    ))  
                                    }
                                </tr>
                                <tr>
                                  <td>Additional Benchmark (₹)##</td>
                                  {productDetail &&
                                    productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.additionalBenchmark && 
                                    productDetail.details[2].performanceData.additionalBenchmark.length > 0 &&
                                    productDetail.details[2].performanceData.additionalBenchmark.map((item, index)=>(
                                      <td>{item.value ? item.value : ""}</td>
                                    ))  
                                    }
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      :''}
                      {productDetail && productDetail.details &&
                        productDetail.details[2] &&
                        productDetail.details[2].performanceData &&
                        productDetail.details[2].performanceData.bottomInfo &&
                        productDetail.details[2].performanceData.bottomInfo.length > 0 ?
                          <div className='disclaimer'>
                            <img src="/images/New/product-solution/overview/infoicon.svg" className='mt-1' alt="info icon" width="15" height="15"/>
                            <div>
                              <p>
                                {isExpanded ? productDetail && productDetail.details &&
                                productDetail.details[2] &&
                                productDetail.details[2].performanceData &&
                                productDetail.details[2].performanceData.bottomInfo : `${productDetail && productDetail.details &&
                                  productDetail.details[2] &&
                                  productDetail.details[2].performanceData &&
                                  productDetail.details[2].performanceData.bottomInfo.slice(0, 340)}...`}
                                  <>
                                  {productDetail && productDetail.details &&
                                    productDetail.details[2] &&
                                    productDetail.details[2].performanceData &&
                                    productDetail.details[2].performanceData.bottomInfo &&
                                    productDetail.details[2].performanceData.bottomInfo.length > 340 && (
                                    <a onClick={toggleReadMore} >
                                      {isExpanded ? ' Read less' : 'Read More'}
                                    </a>
                                  )}
                                  </>
                              </p>
                            </div>
                          </div>
                      :'' }
                    </div>
                  </section>
                  {productDetail && productDetail.details &&
                    productDetail.details[0] &&
                    productDetail.details[0].Overview &&
                    ((productDetail.details[0].Overview.overviewDescription) || (productDetail.details[0].Overview.whyChooseAFund)) ?
                    <section id="Overview">
                      <h2 className='sectionheading'>Overview</h2>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: productDetail.details[0].Overview.overviewDescription,
                          }}
                        />
                        {productDetail && productDetail.details &&
                          productDetail.details[0] &&
                          productDetail.details[0].Overview && 
                          productDetail.details[0].Overview.whyChooseAFund ?
                          <div
                          dangerouslySetInnerHTML={{
                            __html: productDetail.details[0].Overview.whyChooseAFund,
                          }}
                        /> : ''
                        }
                        <div>

                        </div>
                    </section>
                  :""}
                  {productDetail && productDetail.details &&
                    productDetail.details[10] &&
                    productDetail.details[10].keyBenefits &&
                    productDetail.details[10].keyBenefits.length > 0 ?
                  <section id="Benefits">
                    <h2 className='sectionheading'>Key Benefits</h2>
                    {productDetail.details[10].keyBenefits.map((item, index)=>(
                      <div className='d-flex'>
                        <img src="/images/New/product-solution/overview/arrows.svg" alt='Arrow Icon' width="25" height="25"/>
                        <p>{item}</p>
                      </div>
                      ))}
                  </section>
                  :''}
                  <section id="FundDetails">
                    <h2 className='sectionheading'>Fund Details</h2>
                    <div className='row'>
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/Group.svg' alt='Suggested for Icon' className='detailicon'/>
                          <div>
                            <p className="title">Suggested for</p>
                            <p className="descprition">
                            {productDetail && productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.suggestedFor ? productDetail.details[0].Overview.data.suggestedFor : ''}</p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/date.svg' alt='Date Icon' className='detailicon'/>
                          <div>
                            <p className="title">Inception Date</p>
                            <p className="descprition">
                            {productDetail && productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.inceptionDate ? productDetail.details[0].Overview.data.inceptionDate : ''}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/minSIP.svg' alt='Minimum SIP Icon' className='detailicon'/>
                          <div>
                            <p className="title">Minimum SIP</p>
                            <p className="descprition">₹ {productDetail && productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.minimumSip ? productDetail.details[0].Overview.data.minimumSip : ''}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='details'>
                          {productDetail && productDetail.details &&
                            productDetail.details[0] &&
                            productDetail.details[0].Overview &&
                            productDetail.details[0].Overview.data &&
                            productDetail.details[0].Overview.data.risk && 
                            productDetail.details[0].Overview.data.risk[0] && 
                            productDetail.details[0].Overview.data.risk[0].riskIcon ?
                          <img src={productDetail.details[0].Overview.data.risk[0].riskIcon} alt='Risk Icon' className='detailicon'/>
                          :''}
                          <div>
                            <div>
                              <p className="title">Riskometer
                              <div className="producttooltip">
                                <img
                                  src="/images/New/product-solution/overview/information.svg" alt='Information Icon'
                                  className="icon ms-1" width="15" height="15"
                                />
                                <div className="tooltiptext">
                                {productDetail && productDetail.details &&
                                  productDetail.details[0] &&
                                  productDetail.details[0].Overview &&
                                  productDetail.details[0].Overview.data &&
                                  productDetail.details[0].Overview.data.risk && 
                                  productDetail.details[0].Overview.data.risk[0] && 
                                  productDetail.details[0].Overview.data.risk[0].iconUrl &&
                                  productDetail.details[0].Overview.data.risk[0].iconUrl[0] &&
                                  productDetail.details[0].Overview.data.risk[0].iconUrl[0].value ? 
                                  <img
                                    src={productDetail.details[0].Overview.data.risk[0].iconUrl[0].value}
                                    alt='risk icon'
                                  />
                                  : ''}
                                </div>
                              </div>
                              </p>
                            </div>
                            <p className="descprition">
                            {productDetail && productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.risk && productDetail.details[0].Overview.data.risk[0] && productDetail.details[0].Overview.data.risk[0].name ? productDetail.details[0].Overview.data.risk[0].name : ''}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/TRI.svg' alt='TRI Icon' className='detailicon'/>
                          <div>
                            <p className="title">Benchmark</p>
                            <p className="descprition">
                            {productDetail && productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.benchmark && productDetail.details[0].Overview.data.benchmark[0] ? productDetail.details[0].Overview.data.benchmark[0] : ''}
                            </p>
                          </div>
                        </div>
                      </div>
                      {toggleButton == false || (productDetail &&
                        productDetail.banner &&
                        productDetail.banner.categories &&
                        productDetail.banner.categories[0] == "ETF") ? 
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/TER.svg' alt='TER Icon' className='detailicon'/>
                          <div>
                            <p className="title">TER</p>
                            <p className="descprition"><strong>Direct:</strong> 
                            {productDetail &&
                            productDetail.details &&
                            productDetail.details[0] &&
                            productDetail.details[0].Overview &&
                            productDetail.details[0].Overview.data &&
                            productDetail.details[0].Overview.data.terDirecct
                            ? productDetail.details[0].Overview.data.terDirecct
                            : "NA"}
                            </p>
                            <a href='/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports' className='terratio'>View Total Expense Ratio</a>
                          </div>
                        </div>
                      </div>
                      :''}
                      {toggleButton == true && productDetail &&
                        productDetail.banner &&
                        productDetail.banner.categories &&
                        productDetail.banner.categories[0] != "ETF" ? 
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/TER.svg' alt='TER Icon' className='detailicon'/>
                          <div>
                            <p className="title">TER
                            <div className="producttooltip">
                              <img
                                src="/images/New/product-solution/overview/information.svg" alt='Information Icon'
                                className="icon ms-1" width="15" height="15"
                              />
                              <div className="tooltiptext terwidth">
                                {productDetail &&
                                  productDetail.details &&
                                  productDetail.details[0] &&
                                  productDetail.details[0].Overview &&
                                  productDetail.details[0].Overview.data &&
                                  productDetail.details[0].Overview.data.terinfo ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        productDetail.details[0].Overview.data
                                          .terinfo,
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </div> 
                            </p>
                            <p className="descprition"><strong>Regular:</strong> 
                            {productDetail &&
                            productDetail.details &&
                            productDetail.details[0] &&
                            productDetail.details[0].Overview &&
                            productDetail.details[0].Overview.data &&
                            productDetail.details[0].Overview.data.terRegular
                            ? productDetail.details[0].Overview.data.terRegular
                            : "NA"}
                            </p>
                            <a href="/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports" className='terratio'>View Total Expense Ratio</a>
                          </div>
                        </div>
                      </div>
                      :''}
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/entryload.svg' alt='Entry Load Icon' className='detailicon'/>
                          <div>
                            <p className="title">Entry Load
                              {productDetail &&
                              productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.entryLoad ? 
                                <div className="producttooltip">
                                  <img
                                    src="/images/New/product-solution/overview/information.svg" alt='Information Icon'
                                    className="icon ms-1" width="15" height="15"
                                  />
                                  <div className="tooltiptext">
                                    {productDetail.details[0].Overview.data.entryLoad ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: productDetail.details[0].Overview.data.entryLoad,
                                        }}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              :''}
                            </p>
                            <p className="descprition">
                            {productDetail &&
                              productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.entryLoadValue
                              ? productDetail.details[0].Overview.data
                                .entryLoadValue
                              : "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='details'>
                          <img src='/images/New/product-solution/overview/lock.svg' alt='Lock Icon' className='detailicon'/>
                          <div>
                            <p className="title">Lock In
                            {productDetail &&
                              productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.lockIn ? 
                                <div className="producttooltip">
                                  <img
                                    src="/images/New/product-solution/overview/information.svg" alt='Information Icon'
                                    className="icon ms-1" width="15" height="15"
                                  />
                                  <div className="tooltiptext">
                                    {productDetail.details[0].Overview.data.lockIn ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: productDetail.details[0].Overview.data.lockIn,
                                        }}
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              :''}
                            </p>
                            <p className="descprition">
                            {productDetail &&
                              productDetail.details &&
                              productDetail.details[0] &&
                              productDetail.details[0].Overview &&
                              productDetail.details[0].Overview.data &&
                              productDetail.details[0].Overview.data.lockInValue
                              ? productDetail.details[0].Overview.data
                                .lockInValue
                              : "NA"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <h3 className='exitload'>Exit Load</h3>
                      {productDetail &&
                        productDetail.details &&
                        productDetail.details[0] &&
                        productDetail.details[0].Overview &&
                        productDetail.details[0].Overview.data &&
                        productDetail.details[0].Overview.data.exitLoad ? 
                        <div
                          dangerouslySetInnerHTML={{
                          __html: productDetail.details[0].Overview.data.exitLoad,
                          }}
                        />
                        : "NA"}
                      {/* <p className='exitdesc'>In respect of each purchase/switch-in of units, an Exit load of 1% is payable if units are redeemed /switched-out within 30 days from the date of allotment.</p>
                      <p className='exitdesc'>No Exit Load is payable if units are redeemed / switched out after 30 days from the date of allotment.</p> */}
                      <div className='row loadimages'>
                        <div className='col-md-6 mb-5 text'>
                        {productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].productLabelling &&
                          productDetail.details[9].productLabelling.title ? 
                          <h3>{productDetail.details[9].productLabelling.title}</h3> : ''}
                          {productDetail && productDetail.details &&
                            productDetail.details[0] &&
                            productDetail.details[0].Overview &&
                            productDetail.details[0].Overview.data &&
                            productDetail.details[0].Overview.data.risk && 
                            productDetail.details[0].Overview.data.risk[0] && 
                            productDetail.details[0].Overview.data.risk[0].iconUrl &&
                            productDetail.details[0].Overview.data.risk[0].iconUrl[0] &&
                            productDetail.details[0].Overview.data.risk[0].iconUrl[0].value ? 
                          <img src={productDetail.details[0].Overview.data.risk[0].iconUrl[0].value} alt='Risk Icon' className="img-fluid"/> : ''}
                        </div>
                        <div className='col-md-6 mb-5 text'>
                        {productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].benchmarkRiskometer &&
                          productDetail.details[9].benchmarkRiskometer.title ? 
                          <h3>{productDetail.details[9].benchmarkRiskometer.title}</h3> : ''}
                          {productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].benchmarkRiskometer &&
                          productDetail.details[9].benchmarkRiskometer.values ?
                          <div dangerouslySetInnerHTML={{
                            __html: productDetail.details[9].benchmarkRiskometer.values,
                          }} />
                          : ''}
                        </div>
                        {productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].potentialRiskClass && productDetail.details[9].potentialRiskClass.values ?
                        <div className='col-md-5'>
                          {productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].potentialRiskClass &&
                          productDetail.details[9].potentialRiskClass.values ?
                          <div dangerouslySetInnerHTML={{
                            __html: productDetail.details[9].potentialRiskClass.values,
                          }} />
                          : ''}
                        </div>
                        :''}
                        <div className={productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].potentialRiskClass && productDetail.details[9].potentialRiskClass.values ? 'col-md-7' : 'col-md-12'}>
                          {productDetail &&
                          productDetail.details &&
                          productDetail.details[9] &&
                          productDetail.details[9].productLabelling &&
                          productDetail.details[9].productLabelling.values ?
                          <div dangerouslySetInnerHTML={{
                            __html: productDetail.details[9].productLabelling.values,
                          }} />:''}
                          {/* <ul>
                            <li>This product is suitable for investors who are seeking~ </li>
                            <li>To generate long-term capital appreciation/income</li>
                            <li>Investments predominantly in Small-Cap companies</li>
                          </ul> */}
                        </div>
                      </div>
                    </div>
                  </section>
                  {productDetail &&
                  productDetail.details &&
                  productDetail.details[1] &&
                  ((productDetail.details[1].managers &&
                  productDetail.details[1].managers.length > 0) ||
                  (productDetail.details[1].overseasManagers &&
                  productDetail.details[1].overseasManagers.length)) ?
                  <section id="FundManagers">
                    <h2 className='sectionheading'>Fund Managers</h2>
                    <div className="accordion fundacord">
                      {productDetail &&
                      productDetail.details &&
                      productDetail.details[1] &&
                      productDetail.details[1].managers &&
                      productDetail.details[1].managers.length > 0 &&
                      productDetail.details[1].managers.map((item,index)=>(
                        <div className='item'>
                          <div className="title" onClick={() => fundtoggle(index)}>
                            <div className='managerdiv'>
                              <img src='/images/New/product-solution/overview/user.svg' alt='User Profile Icon' className='userprofile'/>
                              <div className='d-flex justify-content-between align-items-md-center w-100'>
                                <div>
                                  <h3 className='name'>{item.managerName ? item.managerName : ''}</h3>
                                  <p className='designation'>{item.desgination ? item.desgination : ''}</p>
                                  <p className='link'>
                                   {checkIframeContent() ? 
                                    <a href="/investor-services/scheme-performance-summary-fund-manager-wise">Click here</a>:<Link
                                    to={getRouting("/investor-services/scheme-performance-summary-fund-manager-wise")}>Click here</Link>} to view all the funds performance managed by the fund manager
                                  </p>
                                </div>
                                <div className='bluearrowdiv'>
                                  <img src='/images/New/product-solution/overview/arrow.svg' alt='arrow' className={fundSelected === index ? "rotate bluearrow" : "bluearrow"}/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={fundSelected === index ? "content show" : "content"}>
                            <p className='subtitle'>{item.other_funds && item.other_funds.title ? item.other_funds.title : ''}</p>
                              <div className='d-flex flex-wrap'>
                              {item && item.other_funds && 
                              item.other_funds.values && 
                              item.other_funds.values.length > 0 &&
                              item.other_funds.values.map((item, index)=>(
                                <span className="badge me-2">{item.title ? item.title: ""}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {productDetail &&
                      productDetail.details &&
                      productDetail.details[1] &&
                      productDetail.details[1].overseasManagers &&
                      productDetail.details[1].overseasManagers.length > 0 && 
                    <h3 className='overseastitle'>Overseas Fund Managers</h3>}
                    <div className="accordion Overseas">
                    {productDetail &&
                      productDetail.details &&
                      productDetail.details[1] &&
                      productDetail.details[1].overseasManagers &&
                      productDetail.details[1].overseasManagers.length > 0 &&
                      productDetail.details[1].overseasManagers.map((item, index)=>(
                        <div className='item'>
                          <div className="title" onClick={() => overseastoggle(index)}>
                            <div className='managerdiv'>
                              <img src='/images/New/product-solution/overview/user.svg' alt='User Profilem Icon' className='userprofile'/>
                              <div className='d-flex justify-content-between align-items-md-center w-100'>
                                <div>
                                  <h3 className='name'>{item.managerName ? item.managerName : ''}</h3>
                                  <p className='designation'>{item.desgination ? item.desgination : ''}</p>
                                  <p className='link'>
                                  {checkIframeContent() ? 
                                    <a href="/investor-services/scheme-performance-summary-fund-manager-wise">Click here</a>:<Link
                                    to={getRouting("/investor-services/scheme-performance-summary-fund-manager-wise")}>Click here</Link>} to view all the funds performance managed by the fund manager</p>
                                </div>
                                <div className='bluearrowdiv'>
                                  <img src='/images/New/product-solution/overview/arrow.svg' alt='Arrow Icon' className={overseasSelected === index ? "rotate bluearrow" : "bluearrow"}/>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={overseasSelected === index ? "content show" : "content"}>
                            <p className='subtitle'>{item.other_funds && item.other_funds.title ? item.other_funds.title : ''}</p>
                              <div className='d-flex flex-wrap'>
                              {item && item.other_funds && 
                              item.other_funds.values && 
                              item.other_funds.values.length > 0 &&
                              item.other_funds.values.map((item, index)=>(
                                <span className="badge me-2">{item.title ? item.title: ""}</span>
                              ))}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>
                  :''}
                  {productDetail &&
                    productDetail.details &&
                    productDetail.details[3] &&
                    productDetail.details[3].top_10_holdings &&
                    productDetail.details[3].top_10_holdings.data &&
                    productDetail.details[3].top_10_holdings.data.length > 0 ?
                  <section id="Portfolio">
                    <h2 className='sectionheading'>Portfolio</h2>
                    {productDetail &&
                      productDetail.details &&
                      productDetail.details[3] &&
                      productDetail.details[3].portfolio ? 
                      <p className='subtitle'>{productDetail.details[3].portfolio}</p>
                    : ''}
                    <div className="table-responsive">
                      <table className="table w-100 Portfolio">
                        <thead>
                          <tr>
                            <th>Company</th>
                            <th>Allocation (%)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {productDetail &&
                            productDetail.details &&
                            productDetail.details[3] &&
                            productDetail.details[3].top_10_holdings &&
                            productDetail.details[3].top_10_holdings.data &&
                            productDetail.details[3].top_10_holdings.data.length > 0 &&
                            productDetail.details[3].top_10_holdings.data.map((item,index)=>(
                              <tr>
                                <td>{item.name ? item.name : ''}</td>
                                <td>{item.persent ? item.persent: ''}%</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </section>
                  :''}
                  {productDetail &&
                    productDetail.details &&
                    productDetail.details[5] &&
                    ((productDetail.details[5].schemeSummaryFiles 
                      && productDetail.details[5].schemeSummaryFiles.length > 0) || 
                      (productDetail.details[5].values && 
                        productDetail.details[5].values.length > 0))?
                  <section id="SchemeDocuments">
                    <h2 className='sectionheading'>Scheme Documents</h2>
                    <div className='row'>
                      {productDetail &&
                        productDetail.details &&
                        productDetail.details[5] &&
                        productDetail.details[5].values &&
                        productDetail.details[5].values.map((item, index)=>{
                        return(
                          <div className='col-md-6 mb-4'>
                            <div className='schemesdiv'>
                              <div className='schemes'>
                                <img src='/images/New/product-solution/overview/download.svg' alt='Download Icon' className='download'/>
                                <div className='w-100'>
                                  <p>{item.description ? item.description : ''}</p>
                                  <div className='d-flex align-items-center justify-content-md-end'>
                                    {item.url ? <a href={item.url} target="_blank"><img src='/images/New/product-solution/overview/pdf.svg' alt='pdf icon' width="28" height="28"/></a>: ''}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                      {productDetail &&
                        productDetail.details &&
                        productDetail.details[5] &&
                        productDetail.details[5].schemeSummaryFiles &&
                        productDetail.details[5].schemeSummaryFiles.map((item, index)=>(
                        <div className='col-md-6 mb-4'>
                          <div className='schemesdiv'>
                            <div className='schemes'>
                              <img src='/images/New/product-solution/overview/download.svg' alt='Download Icon' className='download'/>
                              <div className='w-100'>
                                <p>{item.title ? item.title : ''}</p>
                                <div className='d-flex align-items-center justify-content-md-end'>
                                  {item.more_files && item.more_files.pdf ? <a href={item.more_files.pdf} target="_blank"><img src='/images/New/product-solution/overview/pdf.svg' alt='pdf icon' width="28" height="28"/></a>: ''}
                                  {item.more_files && item.more_files.xls ? <a href={item.more_files.xls} target="_blank"><img src='/images/New/product-solution/overview/xls.svg' alt='xls icon' width="28" height="28" className='mx-2'/></a>: ''}
                                  {item.more_files && item.more_files.xml ? <a href={item.more_files.xml} target="_blank"><img src='/images/New/product-solution/overview/xml.svg' alt='xml icon' width="28" height="28"/></a> : ''}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>:''}
                  {productDetail &&
                    productDetail.details &&
                    productDetail.details[7] &&
                    productDetail.details[7].faqs &&
                    productDetail.details[7].faqs.length > 0 &&
                      <div className='faqdiv'>
                        <h2 className='sectionheading'>Frequently Asked Questions</h2>
                        <div className='productfaqdiv'>
                        {productDetail.details[7].faqs.map((item,index)=>(
                          <div className="item">
                            <div
                              className={faqselected == index ? "title backtitle" : "title"}
                              onClick={() => faqtoggle(index)}
                            >
                              <h2>{item.title ? item.title : ''}</h2>
                              {faqselected == index ?
                                <img
                                  src="/images/New/product-solution/overview/minus.svg"
                                  alt='Minus Icon'
                                  className="ms-2"
                                />
                              :
                                <img
                                  src="/images/New/product-solution/overview/plus.svg"
                                  alt='Plus Icon'
                                  className="ms-2"
                                />
                              }
                            </div>
                            <div
                              className={
                                faqselected == index
                                  ? "content show"
                                  : "content"
                              }
                            >
                              {item.description ? <div
                              dangerouslySetInnerHTML={{
                                __html: item.description,
                              }}
                            /> :''}
                            </div>
                          </div>
                        ))}
                        </div>
                      </div>
                    }
                </div>
              </div>
              <div className='col-md-4 order-1'>
              <div className={isDesktop && isrightFixed ? "rightfloat" : ""}>
                <div id="rightsidebar">
                  <div>
                    {productDetail &&
                      productDetail.banner &&
                      productDetail.banner.promotionalBanners &&
                      productDetail.banner.promotionalBanners.length > 0 &&
                      <div className={productDetail &&
                        productDetail.banner &&
                        productDetail.banner.promotionalBanners &&
                        productDetail.banner.promotionalBanners.length > 1 ? 'staticdiv' : "singleslide"}>
                        <Slider {...settingsNewFund}>
                          {productDetail &&
                            productDetail.banner &&
                            productDetail.banner.promotionalBanners &&
                            productDetail.banner.promotionalBanners.length > 0 &&
                            productDetail.banner.promotionalBanners.map((item, index)=>(
                              <div>
                                <img src={item.url ? item.url : ''} alt={item.alt ? item.alt : ''} className='img-fluid bannerimg'/>
                              </div>
                          ))}    
                        </Slider>   
                      </div>
                    }             
                    <div className={productDetail &&
                        productDetail.banner &&
                        productDetail.banner.promotionalBanners &&
                        productDetail.banner.promotionalBanners.length > 0 ? "padding20" :'backcolor'}>
                      <div className='funddetailsdiv'>
                        <div className='row'>
                        {/* {productDetail &&
                          productDetail.banner &&
                          productDetail.banner.categories &&
                          productDetail.banner.categories[0] != "ETF" ?
                          <div className='col-md-12'>
                            <div className='producttogglediv'>
                              <div className="form-check form-switch d-flex align-items-center">
                                <label className="form-check-label" for="producttoggle">Direct</label>
                                <span className='toggleHolder'>
                                  <Link
                                    to={getRouting(
                                      `/product-solutions/overview/hdfc-flexi-cap-fund-smartlink/${toggleButton === false ? "regular" : "direct"}`
                                    )}
                                  >
                                    <input
                                      className="form-check-input colorSwitch"
                                      type="checkbox"
                                      role="switch"
                                      id="producttoggle"
                                      defaultChecked="checked"
                                      onClick={(e) => handlePlanChange(e)}
                                      checked={toggleButton}
                                    />
                                  </Link>
                                  </span>
                                <label
                                  className="form-check-label"
                                  for="producttoggle"
                                >
                                  Regular
                                </label>
                              </div>
                            </div>
                          </div>
                          :''} */}
                          <div className={isDesktop ? 'col-lg-6 mt-3' : 'col-lg-6 d-flex align-items-start mt-3'}>
                            <p className='title'>NAV 
                            <select
                              className="navdrop"
                              aria-label="Example select with button addon"
                              onChange={handleOverviewNav}
                              value = {preSelectedNav}
                            >
                              {multipleNav &&
                                multipleNav.length > 0 &&
                                multipleNav.map((item, index) => (
                                  <option
                                    value={item.planName}
                                    eventKey={item.planName}
                                  >
                                    {item.planName}
                                  </option>
                                ))}
                            </select>
                            {isDesktop === false ? <div className="producttooltip">
                              <img
                                src="/images/New/product-solution/overview/information.svg"
                                alt='Information Icon'
                                className={isDesktop ? "icon ms-1" : "icon me-1"} width="15" height="15"
                              />
                              <div className="tooltiptext navwidth">
                                <p className='text'>Net Asset Value</p>
                              </div>
                            </div>:""}
                            </p>
                            {multipleNav &&
                              multipleNav.length > 0 &&
                              multipleNav.filter(
                                (item) => item.planName === preSelectedNav
                              ).length > 0 ? (
                              multipleNav &&
                              multipleNav.length > 0 &&
                              multipleNav
                                .filter((item) => item.planName === preSelectedNav)
                                .map((item) => (
                                  <p className={isDesktop ? 'value' : 'value valuemob'}>
                                    {item.navValue ? `Rs ${item.navValue}` : "NA"}
                                    {isDesktop ? <div className="producttooltip">
                                      <img
                                        src="/images/New/product-solution/overview/information.svg"
                                        alt='Information Icon'
                                        className="icon ms-1" width="15" height="15"
                                      />
                                      <div className="tooltiptext navwidth">
                                        <p className='text'>Net Asset Value</p>
                                      </div>
                                    </div>:""}
                                    {multipleNav &&
                                      multipleNav.length > 0 &&
                                      multipleNav.filter(
                                        (item) => item.planName === preSelectedNav
                                      ).length > 0 ? (
                                      multipleNav &&
                                      multipleNav.length > 0 &&
                                      multipleNav
                                        .filter((item) => item.planName === preSelectedNav)
                                        .map((item) => (
                                          <p className='title'>{item.navDate ? `(${item.navDate})` : "NA"}</p>
                                        ))
                                    ) : (
                                      <p></p>
                                    )}
                                  </p>
                                ))
                            ) : (
                              <p className={isDesktop ? 'value' : 'value ms-1'}>NA</p>
                            )}
                          </div>
                          <div className={isDesktop ? 'col-lg-6 mt-3' : 'col-lg-6 d-flex mt-3'}>
                            <p className='title'>Returns 
                              {productDetail &&
                                productDetail.details &&
                                productDetail.details[2] &&
                                productDetail.details[2].performanceData &&
                                productDetail.details[2].performanceData.year &&
                                productDetail.details[2].performanceData.year.length > 0 ?
                                <select className={isDesktop ? 'inceptiondiv' : 'inceptiondiv me-1'}
                                onChange={handleOverviewReturn}
                                value = {preSelectedYear}>
                                  {productDetail.details[2].performanceData.year.map((item, index)=>{
                                      return(
                                        <option value={item.year ? item.year :''}>{item.year ? item.year :''}</option>
                                      )
                                    })}
                                </select> : ''}
                            </p>
                            {productDetail &&
                              productDetail.details &&
                              productDetail.details[2] &&
                              productDetail.details[2].performanceData &&
                              productDetail.details[2].performanceData.annulaisedPer &&
                              productDetail.details[2].performanceData.annulaisedPer.length > 0 
                              ?
                              productDetail.details[2].performanceData.annulaisedPer
                              .filter((item) => item.year === preSelectedYear)
                              .map((item, index)=>{
                                const percentage = item.value; 
                                const number = percentage.replace('%', '');
                                return(
                                  <p className={number > 0  ? 'greenvalue value':'redvalue value'}>{item.value ? item.value : ""}</p>
                                )
                              })
                            :<p className={isDesktop ? 'value': 'value ms-1'}>NA</p>}
                          </div>
                          <div className='col-6 mt-3'>
                            <div className='funddiv'>
                              <p className='title'>Benchmark Returns</p>
                              {productDetail &&
                                productDetail.details &&
                                productDetail.details[2] &&
                                productDetail.details[2].performanceData &&
                                productDetail.details[2].performanceData.benchmarkPer && 
                                productDetail.details[2].performanceData.benchmarkPer.length > 0 ?
                                productDetail.details[2].performanceData.benchmarkPer
                                .filter((item) => item.year === preSelectedYear)
                                .map((item, index)=>{
                                  return(
                                    <p className='value'>{item.value ? item.value : ""}</p>
                                  )
                                })  
                                : <p className='value'>NA</p>}
                            </div>
                          </div>
                          <div className='col-6 mt-3'>
                            <div className='funddiv'>
                              <p className='title'>AUM as on &nbsp;
                              {productDetail &&
                                productDetail.details &&
                                productDetail.details[0] &&
                                productDetail.details[0].Overview &&
                                productDetail.details[0].Overview.data &&
                                productDetail.details[0].Overview.data.aumAsMonth
                                ? productDetail.details[0].Overview.data.aumAsMonth
                                : "-"}
                              </p>
                              <p className='value'>
                               {productDetail &&
                                productDetail.details &&
                                productDetail.details[0] &&
                                productDetail.details[0].Overview &&
                                productDetail.details[0].Overview.data &&
                                productDetail.details[0].Overview.data.aum
                                ? `₹ ${productDetail.details[0].Overview.data.aum} Cr.`
                                : "NA"}</p>
                            </div>
                          </div>
                            
                            {/* {productDetail &&
                              productDetail.banner && (
                              productDetail.banner.categories &&
                              productDetail.banner.categories[0] &&
                              productDetail.banner.categories[0] != "ETF" && 
                              productDetail.banner.hideInvest == false) && isWebViewData && checkIframeContent() &&
                              <div className='col-md-6 mt-3'>
                                <a href='javascript:void(0)' className='addtocart'
                                  onClick={() =>
                                  onAddToCartClick(
                                    productDetail &&
                                    productDetail.banner &&
                                    productDetail.banner.title,
                                    productDetail &&
                                    productDetail.banner &&
                                    productDetail.banner.fundCode,
                                    '',
                                    '',
                                    )
                                }> Add to Cart</a>
                              </div>
                            }                */}
                            {isWebViewData && checkIframeContent() && <>
                              {productDetailOverview &&
                                productDetailOverview.productOverview &&
                                productDetailOverview.productOverview.banner &&
                                productDetailOverview.productOverview.banner.hideInvest == false &&
                                <div className='col-md-12 mt-3'>
                                  <a href="javascript:void(0)" className={isDesktop ? 'investnow' : 'investfloatflex btn'} onClick={investmodalhandleShow}
                                  // onClick={() =>
                                  //   onAddToCartClick(
                                  //     productDetail &&
                                  //     productDetail.banner &&
                                  //     productDetail.banner.title,
                                  //     productDetail &&
                                  //     productDetail.banner &&
                                  //     productDetail.banner.fundCode,
                                  //     '',
                                  //     "Invest Now",
                                  //     )
                                  //   }
                                  > Invest Now</a> 
                                </div>
                                }
                              </>  
                              }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={modalshow}
        onRequestClose={modalhandleClose}
        contentLabel="compare Modal"
        className={
          compareselectedArray.length === 3 ? "compareModalone" : "compareModal"
        }
      >
        <div className="cfmodal">
          <div className="closebtn cursorp" onClick={modalhandleClose}>
            <svg width="44" height="48" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.9998 43.6982C32.0832 43.6982 40.3332 34.9527 40.3332 24.2638C40.3332 13.5749 32.0832 4.82947 21.9998 4.82947C11.9165 4.82947 3.6665 13.5749 3.6665 24.2638C3.6665 34.9527 11.9165 43.6982 21.9998 43.6982Z" fill="#F6F6F6"/>
              <path d="M16.8115 29.7638L27.1882 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M27.1882 29.7638L16.8115 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div className="comparefundmodal">
            <h3>Compare Funds</h3>
            <p className="my-3 bluetext">
              Compare Funds to decide which fund best suits you.
            </p>
            <div className="form-check form-switch d-flex align-items-center mb-4 p-0">
              <label className="form-check-label">Direct</label>
              <input
                className="form-check-input colorSwitch"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault1"
                defaultChecked="checked"
                onClick={(e) => handlePlanChangeCompare(e)}
                checked={toggleButtonCompare}
              />
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckDefault1"
              >
                Regular
              </label>
            </div>
            <div className="search">
              <div className="searchInputs">
                <div className="searchIcon">
                  {filteredData.length === 0 ? (
                    <img
                      className="search"
                      src="/images/New/grey-search.svg"
                      alt="Search Icon"
                    />
                  ) : (
                    <img
                      className="search"
                      src="/images/New/grey-search.svg"
                      alt="Search Icon"
                      id="clearBtn"
                      onClick={clearInput}
                    />
                  )}
                </div>
                <input
                  type="text"
                  placeholder="Search Funds"
                  value={wordEntered}
                  onChange={handleFilter}
                />
              </div>
              {filteredData.length != 0 && (
                <div className="dataResult">
                  {filteredData.slice(0, 15).map((value, key) => {
                    return (
                      <a
                        className="dataItem"
                        href="javascript:void(0)"
                        onClick={(e) => handleAddCard(value.title)}
                      >
                        <p>{value.title} </p>
                      </a>
                    );
                  })}
                </div>
              )}
            </div>
            <p className="mt-4">Note : You can select upto 3 funds.</p>
            <div className="row gx-4 my-4">
              {compareCards &&
                compareCards.length > 0 &&
                compareCards.map((item) => (
                  <div
                    className={
                      compareselectedArray.length < 3
                        ? "col-md-6 mb-4"
                        : "col-md-4 mb-4"
                    }
                  >
                    <div className="card allFundCard h-100">
                      <div className="card-body p-3">
                        <div className="card-title">
                          <div className="mainTitle d-flex justify-content-between">
                            <div className="text-break fundHeading">
                              {item.title ? item.title : ""}
                            </div>

                            <label className="checkboxc">
                              <input
                                type="checkbox"
                                value={item.nodeID ? item.nodeID : ""}
                                checked={item.checked}
                                onChange={(e) => handleRemoveCard(item.nodeID)}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                        </div>
                        {/* <Card.Subtitle className="mb-2 text-muted"><p>__+ Investors have invested in this fund</p></Card.Subtitle> */}
                        <div className="card-text">
                          <div className="aboutfunds">
                          <p className="fundtitle">Returns</p>
                            <div>
                              {item.years &&
                                item.years.length > 0 &&
                                item.years.map((row) => (
                                  <a
                                    className={
                                      item.isActive === row.year
                                        ? "btn fundSubTitlebtn active mb-3"
                                        : "btn fundSubTitlebtn mb-3"
                                    }
                                    onClick={() =>
                                      handleFundYearCompare({
                                        yearName: row.year,
                                        cardID: item.nodeID,
                                      })
                                    }
                                  >
                                    {row.year ? row.year : ""}
                                  </a>
                                ))}
                            </div>
                            <div>
                              <div className="row">
                                {item.cagr &&
                                item.cagr.length > 0 &&
                                item.cagr.filter(
                                  (cagrValue) =>
                                    cagrValue.year === item.isActive
                                ).length > 0 ? (
                                  item.cagr &&
                                  item.cagr.length > 0 &&
                                  item.cagr
                                    .filter(
                                      (cagrValue) =>
                                        cagrValue.year === item.isActive
                                    )
                                    .map((cagrValue) => (
                                      <>
                                        <div className="col-6">
                                          <p className="fundtitle">CAGR</p>
                                          <p className={cagrValue.value > 0 ? "greenfund" : "redfund"}>
                                            {cagrValue.value
                                              ? cagrValue.value
                                              : "NA"}
                                            %
                                            <svg width="24" height="24" className={cagrValue.value > 0 ? "cagrimg" : ''} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M16 14L12 18M12 18L8 14M12 18V6" stroke={cagrValue.value > 0 ? "#008000" : "#EB1C24"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                          </p>
                                        </div>
                                      </>
                                    ))
                                ) : (
                                  <>
                                    <div className="col-6">
                                      <p className="fundtitle">CAGR</p>
                                      <div className="d-flex align-items-center">
                                        <p className="fundpercentage">NA</p>
                                        <p className="navclass ms-1">
                                          (The inception <br></br> date is {item.inceptionDate})
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                )}
                                {item.benchmarkReturns &&
                                item.benchmarkReturns.length > 0 &&
                                item.benchmarkReturns.filter(
                                  (benchmarkReturnsValue) =>
                                    benchmarkReturnsValue.year === item.isActive
                                ).length > 0 ? (
                                  item.benchmarkReturns &&
                                  item.benchmarkReturns.length > 0 &&
                                  item.benchmarkReturns
                                    .filter(
                                      (benchmarkReturnsValue) =>
                                        benchmarkReturnsValue.year ===
                                        item.isActive
                                    )
                                    .map((benchmarkReturnsValue) => (
                                      <>
                                        <div className="col-6">
                                          <p className="fundtitle text-end">
                                            Benchmark Returns
                                          </p>
                                          <p className="fundpercentage text-end">
                                            {benchmarkReturnsValue.value && benchmarkReturnsValue.value !== '0.00'
                                              ? benchmarkReturnsValue.value+'%'
                                              : "NA"}
                                          </p>
                                        </div>
                                      </>
                                    ))
                                ) : (
                                  <>
                                    <div className="col-6">
                                      <p className="fundtitle text-end">
                                        Benchmark Returns
                                      </p>
                                      <p className="fundpercentage text-end">NA</p>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            {/* className="cardfundrow" */}
                            <div>
                              <div className="row  my-3">
                                <div className="col-6">
                                  <p className="fundheadingsec">
                                    {item.real_nav == true ? "iNAV" : "NAV"} (as of&nbsp;
                                    {item.navAsMonth ? item.navAsMonth : ""})
                                  </p>
                                  <p className="fundpercentage">
                                    {item.nav ? item.nav : "NA"}
                                  </p>
                                </div>
                                <div className="col-6">
                                  <p className="fundheadingrisko">
                                    Riskometer
                                    <div className="riskometertooltip">
                                      <img src="/images/New/product-solution/info.svg" className="infoicon" alt="info icon" width={12} height={12} />
                                      <div className="riskotooltiptext">
                                        <img
                                          src={
                                            item.risk &&
                                            item.risk[0] &&
                                            item.risk[0].iconUrl &&
                                            item.risk[0].iconUrl[0] &&
                                            item.risk[0].iconUrl[0].value
                                          }
                                          alt='Risk Icon'
                                        />
                                      </div>
                                    </div>
                                  </p>
                                  <p className="d-flex align-items-center justify-content-end fundpercentage">
                                  <img
                                      src={
                                        item.riskIcon &&
                                        item.riskIcon[0] &&
                                        item.riskIcon[0].value
                                          ? item.riskIcon[0].value
                                          : ""
                                      }
                                      alt='Risk Icon'
                                      className="img-fluid riskimg"
                                    />
                                    <span className="reduceFontsize ms-1">
                                      {item.risk &&
                                        item.risk[0] &&
                                        item.risk[0].name
                                        ? item.risk[0].name
                                        : ""}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="suitable">
                              <p>{item.sutiableFor && item.sutiableFor.title ? item.sutiableFor.title : ''}&nbsp;:&nbsp; <span>{item.sutiableFor && item.sutiableFor.values && item.sutiableFor.values[0]}</span></p>
                            </div>
                            <p className="benchMarkFund">
                              {item.suggestedInvestment && item.suggestedInvestment.title
                                ? item.suggestedInvestment.title
                                : "NA"}
                              &nbsp;:&nbsp;
                              <span>
                                {item.suggestedInvestment && item.suggestedInvestment.values
                                  ? item.suggestedInvestment.values.toString()
                                  : "NA"}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="ordiv my-4">
              <hr />
              <span
                className={
                  compareselectedArray.length < 3
                    ? "orcls px-3"
                    : "orclass px-3"
                }
              >
                Or
              </span>
            </div>

            <h3 className="mb-4">Funds in Focus</h3>
            {compareListTrending &&
              compareListTrending.length > 0 &&
              compareListTrending.map((item) => (
                <div className="treandingscheme">
                  <div className="mb-3 d-flex justify-content-between align-items-center p-3 fundbox">
                    <p>{item.title ? item.title : ""}</p>
                    <label className="checkboxc">
                      {compareselectedArray.length < 3 ||
                        item.checked == true ? (
                        <>
                          <input
                            type="checkbox"
                            value={item.nodeID ? item.nodeID : ""}
                            checked={item.checked}
                            onChange={(e) => handleCompareCheckBox(item)}
                          />
                          <span className="checkmark"></span>
                        </>
                      ) : (
                        <>
                          <input
                            type="checkbox"
                            value={item.nodeID ? item.nodeID : ""}
                            checked={item.checked}
                            disabled
                            onChange={(e) => handleCompareCheckBox(item)}
                          />
                          <span className="checkmark disablecheck"></span>
                        </>
                      )}
                    </label>
                  </div>
                </div>
              ))}
          </div>
          <div className="d-flex">
            <button className="btn btn-outline-primary">
              <Link
                to={getRouting(
                  "/product-solutions/compare-funds",
                  "Compare Funds"
                )}
              >
                Select from list
              </Link>
            </button>
            {compareselectedArray && compareselectedArray.length > 1 ? (
              <button
                className="btn btn-primary ms-3"
                onClick={() => handleModal()}
              >
                <Link
                  to={{
                    pathname: "/product-solutions/comparefunds-details",
                    state: compareselectedArray,
                  }}
                >
                  Compare Funds
                </Link>
              </button>
            ) : (
              <button
                className="btn btn-primary ms-3"
                onClick={() => handleModal()}
                disabled
              >
                <Link
                  to={{
                    pathname: "/product-solutions/comparefunds-details",
                    state: compareselectedArray,
                  }}
                >
                  Compare Funds
                </Link>
              </button>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={investmodalshow}
        onRequestClose={investmodalhandleClose}
        contentLabel="Invest Modal"
        className="InvestModal"
      >
        <div>
          <div className='d-flex'>
            <h2>Invest Via</h2>
            <div className="closebtn cursorp" onClick={investmodalhandleClose}>
              <svg width="44" height="48" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.9998 43.6982C32.0832 43.6982 40.3332 34.9527 40.3332 24.2638C40.3332 13.5749 32.0832 4.82947 21.9998 4.82947C11.9165 4.82947 3.6665 13.5749 3.6665 24.2638C3.6665 34.9527 11.9165 43.6982 21.9998 43.6982Z" fill="#F6F6F6"/>
                <path d="M16.8115 29.7638L27.1882 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M27.1882 29.7638L16.8115 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          {/* {isDesktop ?  */}
          <div className='mt-4 row'>
            <div className='col-md-3 mb-3'>
              <a href="https://angeloneapp.page.link/?link=https%3A%2F%2Fwww.angelone.in%2Fmutual-funds%2Fschemes%2Ffund-isin-inf179k01ut0-schemecode-02t-gr%3Futm_source%3Dpush_cmp&apn=com.msf.angelmobile&isi=1060530981&ibi=com.angelbroking.angeleye" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/angelone.svg' width={120} height={50} />
                <p className='mt-2'>Angle One</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://coin.zerodha.com/mf/fund/INF179K01UT0/hdfc-flexi-cap-fund-direct-growth" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/coin-logo.svg' width={120} height={50} />
                <p className='mt-2'>ZERODHA</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://groww.in/mutual-funds/hdfc-equity-fund-direct-growth" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/groww.svg' width={120} height={50} />
                <p className='mt-2'>Groww</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://paytmmoney.onelink.me/9L59/s3bo8521" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/paytmKaro.svg' width={120} height={50} />
                <p className='mt-2'>Paytm</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://links.dhan.co/?screenName=mfAmc/21273" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/dhanlogo.svg' width={120} height={50} />
                <p className='mt-2'>Dhan</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://etmoney.onelink.me/unJQ/b8hplung" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/et-money.svg' width={120} height={50} />
                <p className='mt-2'>ET Money</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://upstox.com/mutual-funds/hdfc-flexi-cap-fund-direct-growth-details-101344" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/upstox.svg' width={120} height={50} />
                <p className='mt-2'>Upstox</p>
              </a>
            </div>
            <div className='col-md-3 mb-3'>
              <a href="https://kuvera.in/mutual-funds/fund/hdfc-flexicap-growth--02T-GR" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/kuvera.svg' width={120} height={50} />
                <p className='mt-2'>Kuvera</p>
              </a>
            </div>
            {/* <div className='col-md-3 mb-3'>
              <a href="https://hdfcsecinvestright.page.link/2G9T" className='investnow' target={isDesktop ? '_blank' : ''}>
                <img src='/images/New/product-solution/overview/hdfc_securities.svg' width={120} height={50} />
                <p className='mt-2'>HDFC Securities</p>
              </a>
            </div> */}
          </div>
          {/* :
          <div className='mt-4 row'>
            <div className='col-md-2'>
              <a href="javascript:void(0)" className='investnow'
                onClick={() =>
                  onAddToCartClick(
                    productDetail &&
                    productDetail.banner &&
                    productDetail.banner.title,
                    productDetail &&
                    productDetail.banner &&
                    productDetail.banner.fundCode,
                    '',
                    "Invest Now",
                    )
                  }
              >
                <img src='/images/New/product-solution/overview/SWapp.svg'/>
                <p>HDFC Smart Wealth</p>
              </a> 
            </div>
          </div> } */}
        </div>
      </Modal>
    </div>
  )
}
const mapStateToProps = (state) => ({
  productDetailOverview: state.ProductSolution.home.productAllFund,
  postNavList: state.ProductSolution.home.productAllFund,
  compareListData: state.ProductSolution.home.productAllFund,
});

const mapDispatchToProps = (dispatch) => ({
  getSingleFundDetailsquicklink: bindActionCreators(getSingleFundDetailsquicklink, dispatch),
  postNavOverview: bindActionCreators(postNavOverview, dispatch),
  postCompareList: bindActionCreators(postCompareList, dispatch),
  postCompareListDublicate: bindActionCreators(postCompareListDublicate, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FlexiCapPromotionQuickLink);
